@if (hasBackendToggleFeature) {
  <div class="spa-backend-toggle" [class.spa-backend-toggle--label-above]="labelAboveToggle()">
    @if (labelAboveToggle()) {
      <span class="spa-backend-toggle__title">{{ "label.backend" | transloco }}</span>
    }

    <chd-slide-toggle
      data-testid="backend_toggle"
      [ariaLabel]="'label.backend.toggle' | transloco"
      [checked]="isDxBackend()"
      [label]="labelAboveToggle() ? '' : ('label.backend' | transloco)"
      [optionalLabel]="''"
      (checkedChange)="onBackendToggleChange($event)"
    />

    <span class="spa-backend-toggle__label" data-testid="backend_label" aria-live="polite">
      {{ (isDxBackend() ? "label.backend.dx" : "label.backend.material") | transloco }}
    </span>
  </div>
}
